// extracted by mini-css-extract-plugin
export var answers = "style-module--answers--028bb";
export var wrap = "style-module--wrap--3da7a";